import { ShipmentParty } from 'app/generated/backend/shipment/api/shipment-party';
export class SetPartiesRequest {
	shipmentNumber: string;
	shipmentVersion: number;
	parties: ShipmentParty[];
}
